import client from './client';

const dati = (risposta) => risposta.data;

export const listCalendars = () => client.get('/v1/calendars/').then(dati);
export const createCalendar = (body) => client.post('/v1/calendars/', body).then(dati);
export const updateCalendar = (id, body) => client.patch(`/v1/calendars/${id}/`, body).then(dati);
export const deleteCalendar = (id) => client.delete(`/v1/calendars/${id}/`).then(dati);

// Occorrenze di più calendari insieme, con il colore di ciascuno.
export const listOccurrences = (calendars, from, to) =>
  client.get('/v1/occurrences/', { params: { calendars: calendars.join(','), from, to } }).then(dati);

export const getEvent = (id) => client.get(`/v1/events/${id}/`).then(dati);
export const createEvent = (body) => client.post('/v1/events/', body).then(dati);

// Modifica ed eliminazione con ambito: solo questa, questa e le successive, tutte.
export const scopedUpdate = (id, body) =>
  client.post(`/v1/events/${id}/scoped-update/`, body).then(dati);
export const scopedDelete = (id, scope, recurrence_id) =>
  client.post(`/v1/events/${id}/scoped-delete/`, { scope, recurrence_id }).then(dati);

// Pubblicazione su GitHub Gist: l'unico link ICS che funziona da fuori casa.
export const publishGist = (id) => client.post(`/v1/calendars/${id}/gist/`).then(dati);
export const unpublishGist = (id) => client.delete(`/v1/calendars/${id}/gist/`).then(dati);

export const icsLink = (id) => client.get(`/v1/calendars/${id}/ics-link/`).then(dati);
export const regenerateIcsLink = (id) => client.post(`/v1/calendars/${id}/ics-link/`).then(dati);
export const revokeIcsLink = (id) => client.delete(`/v1/calendars/${id}/ics-link/`).then(dati);
export const exportIcs = (id) =>
  client.get(`/v1/calendars/${id}/export/`, { responseType: 'blob' }).then(dati);
